<!-- 选择部门 -->
<template>
  <yxt-drawer
    :title="$t('pc_gwnl_eval_selectDepartment')"
    :visible.sync="dialogVisible"
    size="960px"
    :before-close="beforeDrawClose"
  >
    <template v-if="dialogVisible">
      <yxtbiz-range-selector
        ref="selector"
        :tabs="tabs"
        :function-code="functionCode"
        :data-permission-code="dataPermissionCode"
        v-model="selectedDepts"
        :enableGroupCorp="enableGroupCorp"
        :visibleOrgSelector="visibleOrgSelector"
      />
    </template>
    <div slot="footer">
      <yxt-button @click="beforeDrawClose">
        {{ $t("pc_gwnl_global_btn_cancel") }}
      </yxt-button>
      <yxt-button
        type="primary"
        @click="submit"
      >
        {{ $t("pc_gwnl_global_btn_confirm") }}
      </yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
// import { CheckPersonRange } from 'yxt-biz-pc';
export default {
  name: 'YxtbizEvalSelectDepartment',
  components: {
    // YxtbizCheckPersonRange: CheckPersonRange
  },
  props: {
    visible: Boolean,
    defaultValue: Array,
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    },
    checkStrictly: {
      type: Boolean,
      default: true
    },
    childrenIncluded: [Boolean, Number],
    max: Number,
    enableGroupCorp: {
      type: Boolean,
      default: false
    },
    visibleOrgSelector: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      v1options: {
        errorCallback: function() { },
        updateCallback: function() { },
        headers: {
          token: localStorage.getItem('token'),
          Source: 501
        },
        mutidepart: true, // 是否多选,
        showUserCount: true, // 是否显示部门人数,
        theme: 'frame-department-tree-style1', // 使用皮肤
        searchenable: true,
        data: {
          hasPermission: 1,
          ouRoutingNumbers: [],
          isQueryAllDept: 1 // 1-超级管理员 0-部门管理员
          // 'isOuRoutingNumber': 0,
          // 'removeNumber': '0057',
        }
      },
      tabs: [{
        type: 'department',
        checkStrictly: this.checkStrictly,
        childrenIncluded: this.childrenIncluded
      }],
      rawSelection: {},
      selectedDepts: this.$isV1 ? {} : {
        department: []
      },
      selection: [],
      defaultSelection: []
    };
  },

  computed: {},

  watch: {
    visible() {
      this.dialogVisible = this.visible;
      this.defaultSelection = this.defaultValue && JSON.parse(JSON.stringify(this.defaultValue));
      if (this.visible) {
        if (this.$isV1) { // 兼容1.0
          this.setDefaultValue();
        } else {
          this.$nextTick(() => {
            this.setDefaultValue();
          });
        }
      }
    },
    selectedDepts() {
      this.computedSelection();
    }
  },

  mounted() { },

  methods: {
    setDefaultValue() {
      if (this.$isV1) {
        this.selectedDepts = this.rawSelection;
        const rawKeys = Object.keys(this.selectedDepts);
        const removedKeys = rawKeys.filter(item => !this.defaultSelection.some(value => value.id === item));
        removedKeys.forEach(key => {
          delete this.selectedDepts[key];
        });
      } else {
        this.selectedDepts = this.defaultSelection.map(dept => {
          return {
            ...dept,
            nodeType: 'department'
          };
        });
        // this.$refs.selector.update();
      }
    },
    computedSelection() {
      let selection = [];
      if (this.$isV1) {
        for (const key in this.selectedDepts) {
          if (Object.hasOwnProperty.call(this.selectedDepts, key)) {
            const element = this.selectedDepts[key];
            selection.push({ id: key, name: element.ouName });
          }
        }
      } else if (this.selectedDepts.department) {
        selection = this.selectedDepts.department.map(d => {
          return {
            id: d.id,
            name: d.name,
            includeAll: d.includeAll
          };
        });
      }
      this.selection = selection;
    },
    beforeDrawClose() {
      this.$emit('update:visible', false);
    },
    submit() {
      if (this.$isV1) {
        this.rawSelection = JSON.parse(JSON.stringify(this.selectedDepts));
      }
      if (this.max && this.max < this.selection.length) {
        this.$message.error(this.$t('pc_gwnl_overlimit', [this.max]).d(`超出最大数量${this.max}个`));
        return;
      }
      this.$emit('on-selection', this.selection);
      this.beforeDrawClose();
    }
  }
};

</script>
